<template>
    <section class="practice">
        <vue-snotify></vue-snotify>
        <div class="row">
            <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content successReport col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <div class="row content-row">
                        <div class="col-md-12 top-title">
                            <h3>Focus Success Rate Reports</h3>
                        </div>
                        <!-- begin section-container -->
                        <div class="col-md-12">
                            <div class="section-container section-with-top-border patient_report">
                                <div class=" inner_patient_report">
                                    <div class="row" style="align-items: flex-end;">
                                        <div class="col-lg-3 col-md-6 form-group">
                                            <label>Select Report</label>
                                            <select class="form-control custom-select" v-model="formData.reportType"
                                                required>
                                                <option value="">Select Focus</option>
                                                <option :value="focus.FocusCode" v-for="(focus, i) in allFoucs"
                                                    :key="i">{{
                                                        focus.FocusName }} </option>
                                            </select>
                                        </div>
                                        <div class="col-lg-3 col-md-6 form-group">
                                            <label>Select Year</label>
                                            <select class="form-control custom-select" v-model="formData.reportYear"
                                                required>
                                                <option value="">Select Year</option>
                                                <option :value="year" v-for="(year, i) in years" :key="i">{{ year }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class=" col-md-6 pull-left form-group">
                                            <button @click="resetGoal" class="btn btn-default m-t-20 btn-white"
                                                style="margin-right: 2px;">Reset</button>
                                            <button value="Submit" name="DetailReport"
                                                class="btn btn-primary m-t-20 btn-blue"
                                                @click="getReport">Submit</button>
                                            <button value="Print Report" @click="printReport"
                                                class="btn btn-default btn-white pull-right m-t-20">Print
                                                Report</button>
                                        </div>
                                    </div>
                                    <br>
                                    <div class=" pagination-default clearfix m-b-0" id="printReportBox">
                                        <h4 v-if="printDisplay">Focus Success Rate Report - {{ focusName }} - {{
                                            formData.reportYear }}</h4>
                                        <div class="table-responsive">
                                            <table id="data-table"
                                                class="table table-bordered table-hover patient-report-table">
                                                <thead>
                                                    <tr class="default">
                                                        <th data-sorting="disabled"></th>
                                                        <th style="text-align:center"
                                                            v-for="(report, i) in ReportDataForPDC" :key="i">
                                                            <b>{{ report.title }}</b>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="odd gradeX">
                                                        <td style="font-size:16px"><b>Goal:</b></td>

                                                        <td style="font-size:16px"
                                                            v-for="(report, i) in ReportDataForPDC" :key="i">
                                                            {{ report.m_goal }}
                                                        </td>
                                                    </tr>
                                                    <!-- <template v-if="ReportDataForCA[0][12].userDisplayFlag == 0"> -->
                                                    <tr v-for="(userReport, index) in filteredReportData" :key="index">
                                                        <td><b>{{ userReport[0].ca_name ?? '' }}</b></td>
                                                        <td v-for="(report, ind) in userReport" :key="ind">
                                                            {{ report.m_actual }}
                                                        </td>
                                                    </tr>
                                                    <tr class="even gradeC">
                                                        <td style="font-size:16px" class="subtotal">
                                                            <b>Total:</b>
                                                        </td>
                                                        <!-- Calculate totals for each column -->
                                                        <td style="font-size:16px"
                                                            v-for="(column, columnIndex) in ReportDataForCA[0]"
                                                            :key="columnIndex">
                                                            {{ calculateColumnTotal(columnIndex) }}
                                                        </td>
                                                    </tr>


                                                    <tr class="even gradeC">
                                                        <td style="font-size:16px" class="subtotal">
                                                            <b>Success Rate:</b>
                                                        </td>
                                                        <td style="font-size:16px"
                                                            v-for="(report, i) in ReportDataForCA[0]" :key="i">{{
                                                            report.m_avg }}%</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div>
                                            <span class="pull-left"><b>{{ todayDate() }}</b></span>
                                            <span class="pull-right"><b
                                                    style="width:190px; display:block; letter-spacing: 0.6px;">{{
                                                    loginUser.PracticeName }}</b></span>
                                        </div>
                                    </div>
                                    <!-- end panel -->
                                </div>
                            </div>
                        </div>
                        <!-- end section-container -->

                        <!-- end #content -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
.material-box {
    width: 115%;
}
</style>
<script>
import Vue from "vue";
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import moment from 'moment'
import jsPDF from 'jspdf';

Vue.use(jsPDF)
export default {
    name: "FocusesSuccessReport",
    components: {
        practiceSidebar
    },

    data() {
        return {
            isLoading: false,
            loginUser: {},
            formData: {
                reportType: '',
                reportYear: moment().format('Y'),
                PracticeID: '',
            },
            allFoucs: {},
            years: [],
            year: '',
            ReportDataForCA: {},
            ReportDataForPDC: {},
            focusName: "",
            printDisplay: false,
        }
    },

    methods: {
        calculateColumnTotal(columnIndex) {
            let total = 0;
            this.filteredReportData.forEach(userReport => {
                total += parseFloat(userReport[columnIndex].m_actual || 0); // Summing up m_actual values
            });
            return total;
        },
        todayDate() {
            return moment().format('dddd, MMMM DD, YYYY')
        },
        getYear() {
            let year = parseInt(moment().format('Y'));
            for (let index = 2015; index <= year; index++) {
                this.years.push(index)
            }

        },
        resetGoal() {
            this.formData = {
                reportType: this.allFoucs[0].FocusCode,
                reportYear: moment().format('Y'),
                PracticeID: this.loginUser.PracticeID,
            };

            this.getReport()
        },
        getReport() {
            this.isLoading = true;
            this.getReportDataForPDC()
            this.getReportDataForCA()
        },
        printReport() {
            this.focusName = this.allFoucs.find((val) => {
                return val.FocusCode == this.formData.reportType;
            })['FocusName'];
            this.printDisplay = true;
            let print = document.getElementById('printReportBox');

            const doc = new jsPDF()
            doc.html(print, {
                callback: function (doc) {
                    doc.save("Attendees.pdf");
                },
                margin: [10, 10, 10, 10],
                autoPaging: 'text',
                x: 0,
                y: 0,
                width: 190,
                windowWidth: 875
            }).then(() => {
                this.printDisplay = false;
            }).catch(() => {
                this.printDisplay = false;
            });
        },
        getReportDataForCA() {
            userAPI.getReportDataForCA({ ...this.formData, ...{ PracticeID: this.loginUser.PracticeID } }, res => {
                console.log(res);
                this.ReportDataForCA = res.data;
                this.isLoading = false;
            }, err => {
                console.log(err);
            })
        },
        getReportDataForPDC() {
            userAPI.getReportDataForPDC({ ...this.formData, ...{ PracticeID: this.loginUser.PracticeID } }, res => {
                this.ReportDataForPDC = res.data;
            }, err => {
                console.log(err);
            })
        },
        getAllFoucs() {
            this.isLoading = true;
            userAPI.getAllFoucs(res => {
                this.allFoucs = res.data.data;
                this.formData.reportType = res.data.data[0].FocusCode;
                this.getReportDataForPDC();
                this.getReportDataForCA();
            }, err => {
                console.log(err);
                this.isLoading = false;

            });
        }
    },
    computed: {
        filteredReportData() {
            return this.ReportDataForCA.filter(userReport => {
                // Check if all m_actual values in userReport are zero
                return userReport.some(report => parseInt(report.m_actual) !== 0);
            });
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user;

        if (user.Status == 'DC' || user.Status == 'CA') {
            this.$router.push({ name: 'user_dashboard' });
        }
        this.getYear()
        this.getAllFoucs();
    },
}

</script>